import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-opacity": ".4",
      "fill-rule": "evenodd",
      d: "M8.872 3.308a1.14 1.14 0 0 0-.998-.587h-.47l.57 5.138H11.4zM5.174 6.654a1.14 1.14 0 0 0-.95-.508H3.98l.285 1.712h1.713z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M15.26 7.859c.433 0 .828.244 1.022.63l.064.128c.12.241.12.525 0 .766l-.064.128a1.14 1.14 0 0 1-1.021.63H11.4l-2.528 4.551a1.14 1.14 0 0 1-.998.587h-.47l.57-5.137H5.978l-.803 1.204a1.14 1.14 0 0 1-.95.508H3.98l.285-1.712L4.436 9l-.172-1.142z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }